document.addEventListener('DOMContentLoaded', function() {
  // Announcement Slider start here
  var swiper = new Swiper(".announcement_slider", {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
});
